<template>
  <div>
    <div class="website-settings-input"
         :class="inputClasses">
      <input v-model="url"
             v-validate="'url'"
             name="url"
             type="text"
             ref="urlInput"
             placeholder="url"
             class="text-field"

             @input="onInput"
             @keyup.enter="onAdd">

      <div class="btn-cancel"
           v-if="!urlDuplicateAlert && !urlBlockAlert"
           @click="$emit('hideInput')">
        {{ $t("cancel") }}
      </div>

      <base-button v-if="!urlDuplicateAlert && !urlBlockAlert"
                   class="btn-add"
                   color="secondary"
                   :disabled="isAddButtonDisabled"
                   @click="onAdd">
        <icon-enter iconColor="#000"
                    class="icon-left"
                    width="14"
                    height="14" />
          {{ $t("add") }}
      </base-button>
    </div>
    <website-url-duplicate-alert v-if="urlDuplicateAlert"
                                 :inputType="inputType"

                                 @keep="keepInCurrentList"
                                 @move="moveToAnotherList" />
    <website-url-block-alert v-if="urlBlockAlert && inputType === 'block'"
                             :url="url"

                             @cancel="cancelUrlBloking"
                             @confirm="addUrlSetting" />
  </div>
</template>

<script>
  import WebsiteUrlDuplicateAlert from '@/components/Child/ChildWebsiteSettings/WebsiteUrlDuplicateAlert'
  import WebsiteUrlBlockAlert from '@/components/Child/ChildWebsiteSettings/WebsiteUrlBlockAlert'
  import analytics from '@/services/analytics.js'

  export default {
    props: {
      urlSettings: {
        type: Array,
        required: true
      },

      inputType: {
        type: String,
        required: true
      }
    },

    components: {
      WebsiteUrlDuplicateAlert,
      WebsiteUrlBlockAlert
    },

    data() {
      return {
        url: '',
        urlDuplicateAlert: false,
        urlBlockAlert: false,
        isAddButtonDisabled: true
      }
    },

    mounted() {
      this.$refs.urlInput.focus()
    },

    methods: {
      onAdd() {
        analytics.sendEvent('St_AlwBlk_SiteStgsScr')

        if (!this.url) return

        let url = this.urlSettings.find(
          setting => setting.top_level_domain === this.url
        )

        if (!url && this.inputType === 'allow') {
          this.addUrlSetting()
        } else if (!url && this.inputType === 'block') {
          this.urlBlockAlert = true
        } else if (url && url.action !== this.inputType) {
          this.urlDuplicateAlert = true
        }
      },

      onInput() {
        this.$validator.validate()
          .then(valid => {
            if (!valid) {
              this.isAddButtonDisabled = true
              return
            }

            this.isAddButtonDisabled = false
          })
      },

      addUrlSetting() {
        if (!this.url) return

        this.$emit('addUrl', this.url)
        this.url = ''
        this.urlBlockAlert = false
      },

      keepInCurrentList() {
        this.urlDuplicateAlert = false
        this.url = ''
      },

      moveToAnotherList() {
        this.addUrlSetting()
        this.urlDuplicateAlert = false
        this.url = ''
      },

      cancelUrlBloking() {
        this.urlBlockAlert = false
        this.url = ''
      }
    },

    computed: {
      inputClasses() {
        return {
          'input-alert': this.urlDuplicateAlert,
          'block-alert': this.urlBlockAlert
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .website-settings-input {
    height: 50px;
    background: lighten(map-get($colors, primary), 40%);
    display: flex;
    align-items: center;

    .text-field {
      background: transparent;
      height: 100%;
      width: 50%;

      padding: 0 0 0 32px;
      margin: 0 32px 0 0;
      border: none;
      outline: none;
    }

    .btn-cancel {
      width: 45px;
      height: 18px;
      margin: 0 32px 0 0;
      cursor: pointer;
    }

    .btn-add {
      width: 95px;
      height: 30px;
      font-weight: bold;
      font-size: 14px;
    }
  }

  .input-alert {
    background: lighten(#f25b5b, 25%);
  }

  .block-alert {
    background: lighten(map-get($colors, secondary), 25%);
  }
</style>
